import { Component } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './restaurent-management/core/service/auth.service';

import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { User } from './restaurent-management/core/models/user';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]}
      ],
})

export class AppComponent {
    currentUrl: string
    outletDetailsForDashboard:any;
    private currentUserSubject: BehaviorSubject<User>;
    constructor(
        public _router: Router,
        location: PlatformLocation,
        private spinner: NgxSpinnerService,
        private Idle: BnNgIdleService,
        public platfrmloc: PlatformLocation,
        public authservice: AuthService,
        public modalService : NgbModal
    ) {

        // platfrmloc.onPopState(() => {
        //     history.forward();
        // });

        this._router.events.subscribe((routerEvent: Event) => {
            if (routerEvent instanceof NavigationStart) {
                this.spinner.show();
                location.onPopState(() => {
                    window.location.reload();
                });
                this.currentUrl = routerEvent.url.substring(
                    routerEvent.url.lastIndexOf('/') + 1
                );
            }
            if (routerEvent instanceof NavigationEnd) {
                this.spinner.hide();
            }
            window.scrollTo(0, 0);
        });
        this.Idle.startWatching(2000).subscribe((isTimedOut: boolean) => {
            let that = this;
            localStorage.clear();
            this.modalService.dismissAll();
            that.showTitleErorIcon();

        });
                
    
    }

    
    showTitleErorIcon() {
        this.Idle.stopTimer();
        this._router.navigateByUrl('/authentication/signin');
        localStorage.setItem('UserLogoutType', 'logout');
        Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: 'You\'ve gone idle!.',
            footer: ''
        });
    }
        

}
